import { createActions, createReducer, resettableReducer } from 'reduxsauce';
import { combineReducers } from 'redux';

import { types as loginTypes } from '../auth/login';

export const { Types: types, Creators: actions } = createActions(
  {
    getCustomerProfile: [],
    setFreePlanActive: ['value'],
    setFreePlanDisabled: [],
    activateSubscription: [],

    getCustomerProfileRequest: [],
    getCustomerProfileSuccess: ['data'],
    getCustomerProfileFailure: ['error'],

    // save firebase messaging token
    saveFcmToken: ['token'],
    saveFcmTokenRequest: [],
    saveFcmTokenSuccess: [],
    saveFcmTokenFailure: ['error'],
  },
  { prefix: 'cb/customerProfile/' },
);

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  data: {
    has_active_subscription: false,
    has_free_plan: false,
  },
  error: null,
};

export default resettableReducer(loginTypes.LOGOUT)(
  combineReducers({
    fetching: createReducer(INITIAL_STATE.fetching, {
      [types.GET_CUSTOMER_PROFILE_REQUEST]: () => true,
      [types.GET_CUSTOMER_PROFILE_SUCCESS]: () => INITIAL_STATE.fetching,
      [types.GET_CUSTOMER_PROFILE_FAILURE]: () => INITIAL_STATE.fetching,

      // FCM token saving
      [types.SAVE_FCM_TOKEN_REQUEST]: () => true,
      [types.SAVE_FCM_TOKEN_SUCCESS]: () => INITIAL_STATE.fetching,
      [types.SAVE_FCM_TOKEN_FAILURE]: () => INITIAL_STATE.fetching,
    }),
    fetched: createReducer(INITIAL_STATE.fetched, {
      [types.GET_CUSTOMER_PROFILE_SUCCESS]: () => true,
      [types.GET_CUSTOMER_PROFILE_FAILURE]: () => true,
    }),
    data: createReducer(INITIAL_STATE.data, {
      [types.GET_CUSTOMER_PROFILE_SUCCESS]: (_, { data }) => data,
      [types.ACTIVATE_SUBSCRIPTION]: state => ({
        ...state,
        has_active_subscription: true,
        has_free_plan: false,
      }),
    }),
    error: createReducer(INITIAL_STATE.error, {
      [types.GET_CUSTOMER_PROFILE_REQUEST]: () => INITIAL_STATE.error,
      [types.GET_CUSTOMER_PROFILE_FAILURE]: (_, { error }) => error,
    }),
  }),
);
